import styled from 'styled-components'

import { TypeStyle, fromMd } from '@syconium/little-miss-figgy'

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  max-width: 1280px;
  padding-bottom: 40px;

  ${fromMd} {
    flex-direction: row;
  }
`
export const Header = styled(TypeStyle.HeadlineSmall)`
  padding: 20px 0;
  text-align: center;

  ${fromMd} {
    padding: 40px 0;
  }
`

export const NavWrap = styled.div`
  ${fromMd} {
    flex-grow: 1;
    max-width: 230px;
    min-width: 230px;
    padding: 0 40px;
  }
`

export const TableWrap = styled.div`
  padding: 0 10px;

  ${fromMd} {
    flex-grow: 3;
    min-width: 0;
    padding: 0 40px;
  }
`

export const AltText = styled.p`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  text-align: center;
`
export const BreakLine = styled.hr`
  border: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  border-width: 1px 0 0;
  margin: 20px 0;
`
